import script from "./BankSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./BankSetup.vue?vue&type=script&setup=true&lang=js"

import "./BankSetup.vue?vue&type=style&index=0&id=16f94b6e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f94b6e"]])

export default __exports__